var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMrskidleeyesclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    "data-name": "Layer 10",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.12 407.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d6d6;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e6e6e6;\n        stroke: #e6e6e6;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #848484;\n        stroke: #848484;\n      }\n\n      .cls-4 {\n        fill: #9c9c9c;\n        stroke: #9c9c9c;\n      }\n\n      .cls-5 {\n        fill: #5f5f5f;\n      }\n\n      .cls-5, .cls-6 {\n        stroke: #5e5f5f;\n      }\n\n      .cls-6 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Mirror",
    "data-name": "Colour Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.08,164.53l-7.86-47.57-60-50.82h0l-60,50.82-7.86,47.57,30.78,112.54,37.08,43.86h0l37.08-43.86,30.78-112.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.6,246.99l47.92,24.19s-5.37,25.98-5.37,29.71,9.7,24.34,9.7,24.34l-2.99,10.15,2.09,11.79,9.41,7.61v12.39l4.03,11.05v17.62l-161.76,9.27,23.59-84.19,36.13-53.72,1.96-37.49,11.85-6.91,23.78,17.25-.34,6.95h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "366.4 218.2 351.51 227.31 332.21 223.67 326.6 236.71 296.66 251.28 303.04 238.14 297.89 226.67 279.77 238.71 282.83 227.16 279.77 210.6 284.05 192.98 290.35 185.08 300.91 159.85 321.65 118.78 320.82 102.79 331.26 118.59 332.97 130.07 351.45 149.84 337.99 175.3 343.61 209.5 359.11 219.11 366.4 218.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.43,126.63l8.8-19.24,23.17-1.29s13.99,18.17,11.11,22.97c-2.88,4.81-25.48,12.09-28.02,12.09s-14.02-10.65-13.59-12.07c.43-1.43,1.34-3.6,1.34-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.69,274.95s12.97-2.6,16.85-2.6c0,0,2.53,4.98.45,13.58,0,0,11.67-19.51,11.67-21.6s-20.75,0-20.75,0l-8.21,10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.22,162.86c1.65,0,5.66-1.89,6.9-1.89s2.36,3.13,1.6,4.02-5.54,2.6-8.5,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.84,246.99l-47.92,24.19s5.37,25.98,5.37,29.71-9.7,24.34-9.7,24.34l2.99,10.15-2.09,11.79-9.41,7.61v12.39l-4.03,11.05v17.62l161.76,9.27-23.59-84.19-36.13-53.72-1.96-37.49-11.85-6.91-23.78,17.25.34,6.95h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "144.04 218.2 158.93 227.31 178.23 223.67 183.84 236.71 213.78 251.28 207.4 238.14 212.55 226.67 230.68 238.71 227.61 227.16 230.68 210.6 226.39 192.98 220.1 185.08 209.53 159.85 188.79 118.78 189.62 102.79 179.19 118.59 177.47 130.07 158.99 149.84 172.46 175.3 166.83 209.5 151.34 219.11 144.04 218.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.2,125.49l-5.99-18.09-23.17-1.29s-13.99,18.17-11.11,22.97c2.88,4.81,25.48,12.09,28.02,12.09s14.02-10.65,13.59-12.07c-.43-1.43-1.34-3.6-1.34-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.75,274.95s-12.97-2.6-16.85-2.6c0,0-2.53,4.98-.45,13.58,0,0-11.67-19.51-11.67-21.6s20.75,0,20.75,0l8.21,10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.22,162.86c-1.65,0-5.66-1.89-6.9-1.89s-2.36,3.13-1.6,4.02,5.54,2.6,8.5,2.78"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.92,113.87s8.33-16.34,14.3-19.67c0,0,14.97,14.57,15.97,20.29.48,2.72,17.13-4.88,24.33.84,14.65,11.65,3.01,18.94,3.01,18.94,0,0-15.17,17.77-16,21.94s-6.59,22.35-6.38,23.34.38,9.49-1.29,11.49-16.34,17.52-16.34,17.52l-15.81-1.58-12.19-8.65,4.9,21.05s9.43,5.17,11.77,13.17,5.33,15.88,10.33,21.78c0,0,9.33-18.77,14.67-30.78h2.67l-7.67,39h21.17l3.33-31.23,21.17-105.84-36.72-56.02h-38.79l-23.36,29.46,26.93,14.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.99,135.27s-2.27,3.23-1.89,5.17,11.18,7.32,13.21,10.1,4.52,23.74,4.52,23.74c0,0-5.79-15.5-10.11-15.88s-6.25,9.77-6.25,9.77l-13.54-26.59,1.37-14.56,12.69,8.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.27,225.24s-5.28,5.59-4.75,11.86c0,0-5.36,2.21-8.85,3.41s-3.46,2.12-3.46,2.12l.78-10.55,11.26-21.13,5.01,14.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.29,240.96s-3.13,14.38-5.39,15.67-3.37,1.66-3.37,1.66c0,0-9.35-4.07-10.23-7.28l.59,11.55,20.78,1.69s.45-8.72,0-12.78-2.39-10.51-2.39-10.51h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.9,119.82s-6.44,9.16-6.75,12.38,3.2,27,3,29.11c-.08.79-6.82,5.25-5.32,5.54,2.49.48,12.6-4.38,12.6-4.38,0,0-2.58-13.61-3.73-23.52-1.06-9.11.2-19.13.2-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.97,393.99s-40.85-65.77-49.26-85.57c0,0,7.88,39.86,13.97,56.19s14.18,41.59,14.18,41.59l21.12-12.21h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M213.99,395.31s-20.89-56.19-24.35-78.23c0,0-1.49,45.55,10.15,78.23h14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.41,335.98s2.16,6.72,2.64,12.9c.51,6.48-2.12,4.77-2.12,4.77,0,0-15.36-10.37-20.35-15.96,0,0,9.18,15.9,8.98,19.62s-20.41-5.32-22.94-5.65c0,0,14.36,22.14,23.34,26.13,0,0,6.38,5.24,5.59,12.8s6.38,11.54,6.38,11.54l10.57-8.13-1.49-35.18-10.61-22.83h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.14,395.31s34.07-66.38,38.97-86.89c4.01-16.8-3.07,63.59-16.26,89.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.18,328.75c6.75-27,7.98-44.8,4.6-58,0,0-4.3,27-20.25,60.76s-11.66,70.61-11.66,70.61l66.59-11.54-6.44-24.39-.92-14.08-5.52-4.95s-7.01,8.37-15.76,12.71c-2.01,1-4-1.39-2.65-3.19,5.11-6.82,12.99-18.25,13.19-24.25l3.99-8.29-8.59-15.73s5.22,9.29-.92,15.73c-3.55,3.73-9.26,9.51-13.44,13.72-1.55,1.56-4.18.14-3.72-2.02l1.51-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.14,242.63s3.32-4.44,4.68-1.67-.68,10.02-.68,10.02l4-13.74-3.17-5.91-3.77,3.95-1.06,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M296.14,253.7s22.12-8.45,23.02-5.44-25.25,38.67-25.25,38.67c0,0,35.51-27.35,39.14-27.65s21.44-.15,21.44-.15l-26.26-12.68,1.12-6.49-3.69-.62-29.52,14.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.02,198.33c.17,8.92-8.68,14.65-11.13,16.75s-7.81,6.14-7.81,6.14c0,0,7.35,2.27,9.27,2.27s15.15-9.09,15.15-9.09c0,0,.76,5.6,1.34,6.12s9.66,4.72,9.66,4.72c0,0,.96-8.57.96-10.49s-17.44-16.41-17.44-16.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.68,157.56c-8.55-8.6-1.57-9.09-1.57-9.09l14.86-17.19,1.22-4.27s.7,11.14,0,12.71-5.42,7.35-5.42,7.35c0,0,2.76,20.4,2.89,23.9,0,0-5.19-6.57-11.98-13.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.12,181.43s12.83-15.31,12.83-22.97c0,0-6.7-11.01-7.66-14.2s-7.5-2.71-7.5-2.71c0,0-2.71,5.42-2.71,6.38s10.02,9.89,8.93,14.2-3.89,19.3-3.89,19.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.39,209.5s-8.45-4.15-9.25-8.13c0,0,3.51,15.95,6.38,18.82s11.98,6.7,11.98,6.7l12.27-8.61-7.66,1.6-13.72-10.37h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 265.59,
    y1: 131.27,
    x2: 275.71,
    y2: 140.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.19,164.36s-.26-.57-2.17.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.02,179.55s-7.06-.89-19.8-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302.08,105.12s-12.77-1.47-17.06-1-16.5,5.01-18.09,4.73,1.31-3.93,1.31-3.93c0,0,14.54-2.12,16.69-2.12s17.15,2.33,17.15,2.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.22,207.35s10.77-.02,12.51-.36,20.77-18.77,21.93-21.2,6.43-16.99,10.6-24.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M282.42,195.08s-3.92,14.04-3.26,19.26,2.61,12.24,2.28,15.01-4.9,13.71-4.9,13.71c0,0,16.65-8.49,20.4-13.87,0,0,4.24,8.81,4.24,10.28s-5.21,13.06-7.18,14.85c0,0,32.15-15.67,33.94-17.95s5.06-11.67,5.06-11.67c0,0,18.28,3.02,20.24,3.02s23.5-14.69,23.5-14.69c0,0-13.87,5.06-16.32,5.06s-14.85-8.32-15.18-9.79-4.57-28.4-4.57-30.85,12.89-25.3,12.57-28.07-17.79-18.1-18.44-20.31-4.57-20.49-12.89-27.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M280.77,198.33s-13.68,53.49-14.34,66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.08,274.51s5.34-8.17,7.34-9.51,13.18,1,21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.34,234.24s.23,26.64-3.57,34.68c-3.8,8.04-32.55,50.97-32.55,50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.73,321.79s-49.49-44.84-56.47-55.41-13.32-22.42-17.55-21.78c0,0-.87-2.73,0-3.85s3.86-2.61,3.86-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.88,245.98s45.56,22.54,48.38,22.94-14.5,47.84-18.07,53.87-19.58,28.62-20.9,46.5-.94,28.8-.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M378.12,272.81s-4.18,24.19-4.18,31.53,7.53,16.38,8.28,19.2-1.32,8.53-2.07,10.6.25,9.46,1.63,11.16,7.54,6.17,8.48,8.43.81,9.15.81,11.97,3.83,9.41,3.89,11.67,0,10.73,0,10.73"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 244.86,
    y1: 131.27,
    x2: 234.74,
    y2: 140.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.77,123.34l13.88-1.69s6.95.87,12.8,2.09c2.83.59,9.37,3.26,9.37,3.26,0,0-2.89-6.62-5.01-8.22s-12.43-5.29-12.43-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.29,123.34l-13.88-1.69s-6.95.87-12.8,2.09c-2.83.59-9.37,3.26-9.37,3.26,0,0,2.89-6.62,5.01-8.22s12.43-5.29,12.43-5.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.25,164.36s.26-.57,2.17.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.43,179.55s7.06-.89,19.8-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M208.36,105.12s12.77-1.47,17.06-1,16.5,5.01,18.09,4.73c1.59-.28-1.31-3.93-1.31-3.93,0,0-14.54-2.12-16.69-2.12s-17.15,2.33-17.15,2.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.22,207.35s-10.77-.02-12.51-.36-20.77-18.77-21.93-21.2-6.43-16.99-10.6-24.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M228.03,195.08s3.92,14.04,3.26,19.26-2.61,12.24-2.28,15.01,4.9,13.71,4.9,13.71c0,0-16.65-8.49-20.4-13.87,0,0-4.24,8.81-4.24,10.28s5.21,13.06,7.18,14.85c0,0-32.15-15.67-33.94-17.95s-5.06-11.67-5.06-11.67c0,0-18.28,3.02-20.24,3.02s-23.5-14.69-23.5-14.69c0,0,13.87,5.06,16.32,5.06s14.85-8.32,15.18-9.79,4.57-28.4,4.57-30.85-12.89-25.3-12.57-28.07,17.79-18.1,18.44-20.31,4.57-20.49,12.89-27.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229.68,198.33s13.68,53.49,14.34,66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M251.36,274.51s-5.34-8.17-7.34-9.51-13.18,1-21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.1,234.24s-.23,26.64,3.57,34.68c3.8,8.04,32.55,50.97,32.55,50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.71,321.79s49.49-44.84,56.47-55.41,13.32-22.42,17.55-21.78c0,0,.87-2.73,0-3.85s-3.86-2.61-3.86-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.56,245.98s-45.56,22.54-48.38,22.94,14.5,47.84,18.07,53.87,19.58,28.62,20.9,46.5.94,28.8.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.33,272.81s4.18,24.19,4.18,31.53-7.53,16.38-8.28,19.2,1.32,8.53,2.07,10.6c.75,2.07-.25,9.46-1.63,11.16s-7.54,6.17-8.48,8.43-.81,9.15-.81,11.97-3.83,9.41-3.89,11.67,0,10.73,0,10.73"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Hair_Top_Colour",
    "data-name": "Hair Top Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.73,89.36s5.44,9.45,2.5,21.91-3.45,20-3.45,20l10.35,23.2s-2.96,12.58-12.33,20.29c0,0,11.27,27.9,14.31,32.59s10.35-5.66,10.35-5.66l-6.85,1.07s-7.46-15.2-7.46-23.2,16.04-22.46,16.04-22.46l-10.25-15.53,6.09-22.07,7.46-11.87,2.96,7.91,2.98-19.48,13.91-10.99-2.34,9.01,5.72,22.88,1.28-19.48,13.44-17.55,6.2,5.33,3.2-10.81s6.09,9.28,9.44,20.24,4.26,17.96,4.26,17.96l1.64-17.35-1.9-11.38,13.81,17.82,4.26,15.23,1.37-13.44,15.37,27.09.61,11.57-10.81,14.61,16.59,20.55s-5.02,23.14-5.33,24.35-10.59.11-10.59.11l10.59,4.92s14.61-14.46,17.2-31.35c0,0-13.24-10.65-13.24-17.96s24.22-55.83,24.22-55.83c0,0-14.33-7.49-16.92-15.55s-5.48-26.03-5.48-26.03l-19.48-11.87h20.55l9.44,12.79-8.37-20.48s-30.29-1.9-34.4-5.4-17.35-11.11-17.35-11.11l-4.57,17.35-25.88-20.85s-18.42,18.42-25.27,18.42-28.46-5.33-36.83-15.53,15.68,27.55,19.33,29.07,30.79-4.87,33.05-10.65,13.68-10.2,13.68-10.2l14.87,13.55-19.79-2.28-27.66,15.53-29.07,20.09-10.35,15.53,1.37,15.5,6.7-19.3,10.85-.76-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.97,83.26s17.88-16.35,20.18-21.07,18.02-11.49,18.02-11.49c0,0-.33,2.94,2.32,3.96s20.87-2.81,23.83-2.55c0,0-13.35,10.98-15.41,15.84s-10.73,14.18-10.73,14.18c0,0,1.78-10.34.75-11.49s-23.75,46.34-23.75,46.34l.51-20.67s7.03-10.09,7.09-14.81c0,0-12.46-5.24-22.8,1.79v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.13,38.01s13.26,13.38,23.13,9.5,11.9-9.5,11.9-9.5c0,0-18.76,9.88-35.04,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.9,94.91s6.63-17.01,7.75-20.38c1.12-3.37,10.95-11.5,10.95-11.5l-5.2,14.01-13.5,17.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.68,69.47l-1.64-7.57s13.01,8.61,19.51,5.3,0-20.18,0-20.18c0,0,10.88,5.13,13.26,8.38s6.5,7,6.5,10.13,2,10.38,4.5,14.13c0,0,.25,22.38.75,27.89,0,0-5.38-18.51-13.51-24.51,0,0-9.19-1-15.6-10.38,0,0,.59,12.25-2.53,13.26s-8.97-3.12-11.24-16.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.8,22.97s7.8,13.48,10.48,14.54,8.74,3.18,13.54-1.12c0,0-5.24-.87-6.8-1.62s-17.22-11.79-17.22-11.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.31,142.19s9.87-1.47,14.47-9.99c0,0-11,19-8.23,24.94s10.02,14.48,8.72,17.45-17.45-3.53-23.95-17.64c0,0,8.28-9.75,8.99-14.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.83,163.06s-2.01,12.86,9.33,2.27c0,0-3.96,3.01-7.22,6.92s.92,14.18-2.08,14.18-10.03-12.05-10.03-12.05l9.99-11.32h.01Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.11,319.89s13.67,15,14.05,17.93-1.91,15.41-1.91,23.43,3.31,32.73,3.31,32.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.41,72.02c-1.46,6.2-10.57,18.48-10.57,22.85s6.69,27.11,6.69,27.11c-.36-7.17,2.8-19.45,3.27-21.76s10.95-18.48,12.53-18.35,6.2,7.17,6.2,7.17c0,0,1.46-12.03,2.8-12.16s10.82,27.96,11.43,34.03.49,14.57.49,14.57c0,0,4.13-25.15,4.13-27.34s-6.69-28.69-6.69-28.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.89,69.47s-11.25,28.79-10.41,33.91,5.18,22.11,5.18,22.11c0,0-.12-22.72,2.31-27.34s13.93-14.46,13.93-14.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.15,88.18s11.06,11.79,12.88,18.96,3.52,19.08,3.52,19.08c0,0,2.19-22.61,2.19-25.77s-6.81-20.91-6.81-26.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.52,48.16c2.21.83,18.22.97,18.22.97,2.76,6.9,18.5,24.47,18.5,24.47-5.94-6.04-15.88-34.14-15.88-34.14-8.15,1.24-27.47-4.28-31.89-5.11s-21.12-12.84-21.12-12.84c-2.9,3.59-5.94,17.95-5.94,17.95,0,0-20.28-19.25-24.74-20.92,0,0-12.67,16.57-29.1,18.66s-39.25-21.58-39.25-21.58c0,0,15.59,31.46,23.95,37.59s30.71-5.85,32.9-8.07,10.4-11,14.3-11,13.92,10.47,13.92,10.47c0,0-13.17-4.19-16.59-4.19s-23.92,10.8-35.24,21.24c-11.32,10.44-22.66,14.8-22.66,14.8,0,0-9.61,14.48-12.53,17.96,0,0,.97,16.43,3.06,24.36,0,0,4.32-24.09,9.61-26.45s31.88-8.91,36.62-16.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214.32,108.5s-12.91,22.44-13.12,29.85c-.21,7.41,11.43,14.82,11.43,17.99s-15.66,15.24-16.93,21.59,3.6,19.9,6.56,22.65,14.18-4.23,14.18-4.23c0,0-11.43,11.85-16.3,13.12s-18.2-31.75-18.63-35.14c0,0,13.97-12.49,12.7-19.05s-9.95-22.65-9.74-25.82,8.89-17.99,3.18-37.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M295.03,107.5s13.91,23.44,14.12,30.85c.21,7.41-11.43,14.82-11.43,17.99s15.66,15.24,16.93,21.59-3.6,19.9-6.56,22.65-14.18-4.23-14.18-4.23c0,0,11.43,11.85,16.3,13.12,4.87,1.27,18.2-31.75,18.63-35.14,0,0-13.97-12.49-12.7-19.05s9.74-25.82,9.74-25.82l13.93-29.54s-9.11-2.19-13.81-10.34-7.73-29.82-8.7-30.51-31.48-18.5-34.38-18.64-13.94,1.24-13.94,1.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrskidleeyesclosed);
export default __webpack_public_path__ + "static/media/mrsk idle eyes closed.b1e3fa65e21d695f2fb2d2e9f689db69.svg";
export { ForwardRef as ReactComponent };